<template>
  <div v-if="$authState.isAuthenticated && $authState.user" class="user-info-card">
    <div class="user-info-card__content">
      <div class="user-info-card__avatar">
        {{ userInitial }}
      </div>
      <div class="user-info-card__details">
        <p class="user-info-card__welcome">👋 欢迎来到 Vue2 子应用</p>
        <h3 class="user-info-card__name">{{ userName }}</h3>
        <p class="user-info-card__email">📧 {{ userEmail }}</p>
      </div>
      <div class="user-info-card__badge">
        ✅ 已认证
      </div>
    </div>
    <div class="user-info-card__notice">
      <p>
        🔐 <strong>认证说明：</strong>此用户信息由主应用通过 qiankun 全局状态同步而来，
        演示了微前端架构中的认证状态共享机制。
      </p>
    </div>
  </div>
  <div v-else class="user-info-card user-info-card--warning">
    <p>⚠️ 未登录状态（或独立运行模式）</p>
  </div>
</template>

<script>
export default {
  name: 'UserInfoCard',
  computed: {
    userName() {
      return this.$authState.user?.name || '未知用户'
    },
    userEmail() {
      return this.$authState.user?.email || ''
    },
    userInitial() {
      const name = this.$authState.user?.name || 'U'
      return name.charAt(0).toUpperCase()
    }
  },
  watch: {
    '$authState.user': {
      handler(newVal) {
        console.log('[Vue2 UserInfoCard] User state changed:', newVal)
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.user-info-card {
  padding: 1.5rem;
  margin: 1rem 0;
  background: linear-gradient(135deg, #42b983 0%, #2d7b5c 100%);
  border-radius: 12px;
  color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.user-info-card--warning {
  background: #fff3cd;
  border: 1px solid #ffc107;
  color: #856404;
  padding: 1rem;
}

.user-info-card--warning p {
  margin: 0;
}

.user-info-card__content {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.user-info-card__avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: bold;
  flex-shrink: 0;
}

.user-info-card__details {
  flex: 1;
}

.user-info-card__welcome {
  margin: 0;
  font-size: 0.875rem;
  opacity: 0.9;
}

.user-info-card__name {
  margin: 0.25rem 0;
  font-size: 1.5rem;
}

.user-info-card__email {
  margin: 0;
  font-size: 0.875rem;
  opacity: 0.8;
}

.user-info-card__badge {
  padding: 0.5rem 1rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  font-size: 0.875rem;
  flex-shrink: 0;
}

.user-info-card__notice {
  margin-top: 1rem;
  padding: 0.75rem;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  font-size: 0.875rem;
}

.user-info-card__notice p {
  margin: 0;
}

@media (max-width: 640px) {
  .user-info-card__content {
    flex-direction: column;
    text-align: center;
  }

  .user-info-card__badge {
    width: 100%;
  }
}
</style>
